import { PersonController } from './person.controller';
import template from './person.html';

export const confirmWarrantPersonComponent = {
  name: 'confirmWarrantPerson',
  restrict: 'E',
  template,
  controller: PersonController,
  controllerAs: 'vm',
  bindings: {
    model: '=',
    form: '=',
    translatePrefix: '@',
  },
};
